import { LayerType } from '@pn/core/domain/layer';
import { buildQuery } from '@pn/core/domain/query';
import {
  createInitInternalState,
  ItemsFolder,
  type WorkspaceItem,
} from '@pn/core/domain/workspace';
import { isProduction } from '@pn/core/utils/env';
import { DEFAULT_POLYGON_OPACITY } from '@pn/services/styles';
import { generateMapConfig, setOriginalLayers } from '.';

export const open_mineral_rights: WorkspaceItem = setOriginalLayers({
  country: 'canada',
  folder: ItemsFolder.Public,
  isTemporary: false,
  id: 'open_mineral_rights',
  dataType: 'open_mineral_rights',
  itemType: 'layer',
  numberOfElements: undefined,
  createdBy: undefined,
  name: 'Open Rights',
  description: '825k lands in Canada',
  origin: 'pn',
  createdAt: '1970-01-01T00:00:00.000Z',
  updatedAt: '1970-01-01T00:00:00.000Z',
  isShared: false,
  isGlobal: true,
  map: generateMapConfig({
    itemId: 'open_mineral_rights',
    type: LayerType.Polygon,
    style: {
      color: `hsla(20, 100%, 60%, ${DEFAULT_POLYGON_OPACITY})`,
    },
    source: {
      type: 'vector',
      url: isProduction()
        ? 'mapbox://sbilston.production-open-mineral_rights'
        : 'mapbox://sbilston.staging-open-mineral_rights',
    },
    sourceLayer: 'open_mineral_rights',
    renderAsPoints: true,
  }),
  dataSource: {
    type: 'api',
    source: 'parquet',
    url: 'v2/layers/open_mineral_rights',
    requiredMapDataFields: ['internal_id', 'geometry'],
    requiredTableDataFields: ['internal_id', 'geometry', 'open_rights'],
  },
  detailsSource: 'local',
  query: buildQuery({
    id: 'open_mineral_rights',
    dataType: 'open_mineral_rights',
  }),
  ...createInitInternalState({ isVisualized: false }),
});
